<template>
  <div class="uwb-page">
    <iframe width="100%" :src='myURL' frameborder="no" style="border: 0;height: 100%;"></iframe>
  </div>
</template>

<script>
export default {
  data(){
    return{
      myURL:'/uwb/index1.html'
    }
  },
  mounted(){

  },
}
</script>

<style scoped>
  .uwb-page{
    width: 100%;
    height: 100vh;
    position: relative;
  }
</style>